<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Notifica Notipay" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Soggetto:</label>
                    <span class="sa-data">{{ jsonData.subject }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Codice Fiscale:</label>
                    <span class="sa-data">{{ jsonData.fiscalCode }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Stato:</label>
                    <span class="sa-data">{{ jsonData.status }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Data ora invio:</label>
                    <span class="sa-data">{{ jsonData.sentAt }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Messaggio:</label>
                    <span class="sa-data" v-html="jsonData.message"></span>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import NotificationNotipayMixin from "../mixin/NotificationNotipayMixin";
export default {
    mixins: [NotificationNotipayMixin],
    data() {
        return {
            pathResource: "/notificationnotipay",
            id: "-1",
            jsonData: {},
        };
    },
    watch: {},
    mounted() {},
    methods: {
        init(id) {
            this.id = id;
            this.loadData();
        },
        loadData() {
            this.notificationNotipayDettaglioLoadData(this.id, this.afterLoadData);
        },
        afterLoadData() {
            this.jsonData = this.notificationNotipayDettaglio;
        },
    },
};
</script>
